import newMat from './createNewMaterials/';
import requestedMaterials from './requestedMaterials/';

export default {
  cataloger: {
    pages: {
      ...newMat,
      ...requestedMaterials,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/index.js